module.exports = __webpack_public_path__ + "img/clerk-route.9af7c579.png";